var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.renderValue)?_c('div',{staticClass:"time-argument"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.renderValue))])]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }